import { Circle, DollarSign, Home, Settings, Users } from "react-feather"
import { AiOutlineBars, AiOutlineHighlight } from "react-icons/ai"
import { ownUrl } from "../../views/Validator"
import { DefaultNav } from "./DefualtNav"
export const EmailNavigation = [
    ...DefaultNav,
    {
        header: 'email'
    },
    //     {
    //       id: 'builder',
    //       title: 'Builder',
    //       icon: <img style={{marginRight: '18px'}} src={`${ownUrl}/frontbase/website-slide/navbar/customer_group.png`} width='16px' />,
    //       navLink: '/merchant/Email/builder'
    //   },
    {
        id: 'e,dashboard',
        title: 'Dashboard',
        icon: <Home />,
        navLink: '/merchant/email/'
    },
    {
        id: 'send',
        title: 'Templates',
        icon: <AiOutlineHighlight />,
        navLink: '/merchant/Email/templates'
    },
    {
        id: 'campaign',
        title: 'Campaign',
        icon: <AiOutlineBars />,
        navLink: '/merchant/Email/campaign'
    },
    {
        id: 'Email',
        title: 'Contacts',
        icon: <img style={{ marginRight: '18px' }} src={`${ownUrl}/frontbase/website-slide/navbar/customer_group.png`} width='16px' />,
        navLink: '/merchant/Email/contacts'
    },
    {
        id: 'group',
        title: 'Groups',
        icon: <Users />,
        navLink: '/merchant/Email/group'
    },
    {
        id: 'Billing',
        title: 'Billing',
        icon: <DollarSign size={16} />,
        navLink: '/merchant/email/Billing/'
    },
    {
        id: 'setting',
        title: 'Settings',
        icon: <Settings size={16} />,
        // icon: <img style={{ marginRight: '18px' }} src={`${ownUrl}/frontbase/website-slide/navbar/crm.png`} width='16px' />,
        children: [
            {
                id: 'SMsetting',
                title: 'SMTP Settings',
                icon: <Settings />,
                navLink: '/merchant/Email/settings'
                // },
                // {
                //     id: 'verify_your_domain',
                //     title: 'Verify your Domain',
                //     icon: <Circle size={16} />,
                //     navLink: '/merchant/campaign/verify_your_domain/'
                // },
                // {
                //     id: 'verify_your_email',
                //     title: 'Verify your Email',
                //     icon: <Circle size={16} />,
                //     navLink: '/merchant/campaign/verify_your_email/'
            }
        ]
    },
    {
        id: 'trigger',
        title: 'Trigger',
        icon: <Settings />,
        navLink: '/merchant/Email/trigger'
    }
    // {
    //     id: 'billing',
    //     title: 'Billing',
    //     icon: <BiDollar size={16} />,
    //     navLink: '/merchant/SuperLeadz/billing/'
    //   },
    //   {
    //     id: 'faq',
    //     title: 'FAQs',
    //     icon: <AiOutlineQuestion size={16} />,
    //     navLink: '/merchant/SuperLeadz/faq/'
    //   },
    //   {
    //     id: 'support',
    //     title: 'Support',
    //     icon: <AiFillPhone size={16} />,
    //     navLink: '/merchant/support/'
    //   }
]